module.exports = __webpack_public_path__ + "img/promotions.843b2b4a.svg";